<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup">
    <wbo-edit-page-footer-controls>
        <wbo-switch-edit-control class="advanced-switch"
                                 [label]="'wbo.common.button.advanced'"
                                 [(value)]="pageState.advanced">
        </wbo-switch-edit-control>
    </wbo-edit-page-footer-controls>
    <fui-formation-group [title]="'wbo.order-ready-display.edit.formation.details'" [formControlNames]="''">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control [(ngModel)]="model.data.name"
                                               formControlName="name"></wbo-text-edit-control>
                        <wbo-text-edit-control [(ngModel)]="model.data.title"
                                               formControlName="title"></wbo-text-edit-control>
                        <fui-column>
                            <wbo-site-single-select-edit-control [(ngModel)]="model.data.site"
                                                                 [readonlyOnEdit]="true"
                                                                 (valueChange)="changeSite()"
                                                                 formControlName="site"></wbo-site-single-select-edit-control>
                        </fui-column>
                        <fui-column
                                    [label]="'wbo.order-ready-display.edit.field-set.orderLocation'">
                            <wbo-outlet-multi-select-edit-control formControlName="outletIds"
                                                                  [(ngModel)]="model.data.outletIds"
                                                                  (valueChange)="outletsChanged()">
                            </wbo-outlet-multi-select-edit-control>
                            <fui-message-label [title]="'wbo.common.label.or'"></fui-message-label>
                            <wbo-terminal-multi-select-edit-control formControlName="terminalIds"
                                                                    [(ngModel)]="model.data.terminalIds"
                                                                    (valueChange)="terminalsChanged()">
                            </wbo-terminal-multi-select-edit-control>
                            <fui-message-label [title]="'wbo.common.label.or'"></fui-message-label>
                            <wbo-web-terminal-multi-select-edit-control formControlName="webTerminalIds"
                                                                     [site]="model.data.site"
                                                                     [excludeAssignedSites]="!model.data.site"
                                                                     [(ngModel)]="model.data.webTerminalIds"
                                                                     (valueChange)="webTerminalsChanged()">
                            </wbo-web-terminal-multi-select-edit-control>
                        </fui-column>
                        <fui-column *ngIf="showAdvancedContent">
                            <fui-prepend-field>
                                <wbo-checkbox-edit-control [(ngModel)]="model.data.displayTakeawayOrders"
                                                           formControlName="displayTakeawayOrders"></wbo-checkbox-edit-control>
                                <wbo-checkbox-edit-control [(ngModel)]="model.data.displayTableOrders"
                                                           formControlName="displayTableOrders"></wbo-checkbox-edit-control>
                            </fui-prepend-field>
                            <ng-container *ngIf="model.data.displayTakeawayOrders || model.data.displayTableOrders">
                                <wbo-meta-tag-multi-select-edit-control formControlName="orderReadyQualifiers"
                                                                        [type]="MetaTagType.ORDER_READY_QUALIFIER"
                                                                        [includeMatchNoTags]="true"
                                                                        [matchNoTagsLabel]="'wbo.meta-tag.option.modifier.unqualified'"
                                                                        [multiObjectValueType]="true"
                                                                        [(ngModel)]="model.data.orderReadyQualifiers"></wbo-meta-tag-multi-select-edit-control>
                            </ng-container>
                            <wbo-numeric-edit-control formControlName="orderOverdueMinutes"
                                                      [notation]="'wbo.common.label.minutes' | translate"
                                                      [digitInfo]="'1.0-0'"
                                                      [(ngModel)]="model.data.orderOverdueMinutes">
                            </wbo-numeric-edit-control>
                        </fui-column>
                    </fui-column>
                    <fui-column>
                        <wbo-image-edit-control formControlName="backgroundImage"
                                                [showOpacitySlider]="true"
                                                [(ngModel)]="model.data.backgroundImage"
                                                [(imageOpacity)]="model.data.backgroundImageOpacity">
                        </wbo-image-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
